<template>
  <div class="MainDiv" v-bind:class="{ 'heightAuto': !autoCompleteVisible, 'height300' : autoCompleteVisible}">
    <div class="container-fluid ">
		  <div class="row margin-Top-2Perc margin-bottom-2Perc">
        <div class="col-xs-8 col-sm-3 col-md-3 col-lg-2 margin-top-3px font-size-18px padding-left-1Point8Perc">
          {{isComingFrom === constants.CourseSearchBarEnum.Course ? 'MASTER CLASS' : 'ASSESSMENT'}} 
        </div>
        <!-- <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 text-align-left padding-left-0Perc"> -->
          <!-- <div class="row"> -->
            <div class="col-xs-8 col-sm-6 col-md-4 col-lg-4 padding-left-0Perc">
              <div class="form-group margin-bottom-0Perc">
                <div class="icon-addon addon-lg">
                  <input type="text" ref="input" class="form-control background-gray border-rounded" autocomplete="off" id="search" v-on:focus="increaseComponentHeight($event)" v-on:blur="decreaseComponentHeight($event)"/>
                  <label class="glyphicon glyphicon-search"></label>
                  <typeahead v-model="selectedCourseObj" target="#search" :data="courses" id="typeheadSearch" item-key="LongTitle" :limit="20" append-to-body :open-on-empty="true"></typeahead>
                  <!-- <autocomplete source="courses" results-property="CourseTitle" results-display="selectedCourseObj"></autocomplete>       -->
                </div>
              </div>
            </div>
            <!-- <div class="col-lg-1"> -->
            <div class="col-xs-3 col-sm-2 col-md-1 col-lg-1 padding-left-0Perc text-align-center">  
              <button type="button" class="btn black-border custom-btn white-BG col-xs-12 col-sm-12 col-md-12 col-lg-12" v-on:click="showLessonList">Go</button>
            </div>
            <div class="col-xs-4 col-sm-1 col-md-2 col-lg-1 padding-top-32px margin-top-Point1Perc width-0Perc padding-left-0Perc padding-right-0Perc" :class="{'left-border' : isComingFrom === constants.CourseSearchBarEnum.Course}">
            </div>
            <div class="col-xs-8 col-sm-3 col-md-2 col-lg-2">
              <button type="button" v-if="isComingFrom === constants.CourseSearchBarEnum.Course" class="btn black-border custom-btn white-BG col-xs-12 col-sm-12 col-md-12 col-lg-9" v-on:click="updateClickedCreateCourse($event)">+ Create New</button>
            </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
  </div>  
</div>
</template>

<script>
import csvHelper from '@/utils/csv-helper'
import { constants } from '@/utils/constants'
import { moduleService } from '@/server-util/module-service'
import { courseService } from '@/server-util/course-service'
import { elementService } from '@/server-util/element-service'
import { Typeahead } from 'uiv'
import { filter } from 'lodash'
import Autocomplete from 'vuejs-auto-complete'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
export default {
  props: ['newlyCreatedCourseObj', 'isComingFrom'],
  created: function () {
    this.openSelectedCourse()
  },
  data: function () {
    return {
      constants: constants,
      clickedCreateCourse: true,
      selectedCourseObj: null,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      autoCompleteVisible: false,
      showUploadCourseCSVOverlay: false,
      showValidateCourseOverlay: false,
      serverResp: {},
      serverErrorRespArr: [],
      selectedErrorObj: {},
      showUpdateBonusElemOverlay: false,
      showUpdateVideoElemOverlay: false,
      showUpdateRDElemOverlay: false,
      showUpdateNoteElemOverlay: false,
      showUpdateChallengeElemOverlay: false,
      showUpdateDocumentElemOverlay: false,
      showUpdateMCQElemOverlay: false,
      showUpdateCourseOverlay: false,
      selectedErrorElemObj: {},
      selectedErrorModuleObj: {},
      showMsg: false,
      isBonusModuleCreated: true,
      showSelectElemTypeOverlay: false,
      showBonusModuleCreationOverlay: false,
      showAddBonusVideoElementOverlay: false,
      showCreateChallengeElemOverlay: false,
      showCreateDocumentElemOverlay: false,
      showCreateMcqElemOverlay: false,
      showCreateNoteElemOverlay: false,
      showCreateRDElemOverlay: false,
      showCreateVideoElemOverlay: false,
      isAllErrorFixed: false,
      courseId: ''
    }
  },
  methods: {
    openSelectedCourse: function () {
      // AK: If user coming from manange course page then show selected course
      this.courseId = this.$route.query.courseId
      // console.log('this.courseId >>> ' + this.courseId)
      if (this.courseId !== undefined) {
        for (var i = 0; i < this.$store.state.course_list.length; i++) {
          // console.log('this.$store.state.course_list[i] ' + JSON.stringify(this.$store.state.course_list[i]))
          if (this.$store.state.course_list[i].CourseMasterId === this.courseId) {
            this.selectedCourseObj = this.$store.state.course_list[i]
          }
        }
        // console.log('this.selectedCourseObj From URL>>> ' + JSON.stringify(this.selectedCourseObj))
        this.getLessons()
        this.$store.state.hightLightOptionExplictly = false
      }
    },
    downloadCourseCSVTemplate: function () {
      // AK: Used to download Course CSV file
      var columnAlias = ['Course Title', 'Course Sub-title', 'Lesson Name', 'Element Type', 'Element Title', 'Element Text Content', 'Kaltura Entry ID', 'Kaltura Basic ID']
      var columnRespKey = ['', '', '', '', '', '', '', '']
      return csvHelper.export(null, columnRespKey, columnAlias, 'CourseTemplate')
    },
    updateShowSelectTypeOverlayState (value) {
      // AK: Used to handle the case if user select or directly closed the Select Element type overlay for creating new element
      this.closeAllOverlay()
      this.showSelectElemTypeOverlay = false
      // AK: If user selected element then only perform next operations
      if (value.isUserSelectedElemType) {
        switch (parseInt(value.selectedElementType)) {
          case 0:
            this.showCreateVideoElemOverlay = true
            break
          case 1:
            this.showCreateChallengeElemOverlay = true
            break
          case 2:
            this.showCreateRDElemOverlay = true
            break
          case 3:
            this.showCreateMcqElemOverlay = true
            break
          case 6:
            this.showCreateNoteElemOverlay = true
            break
          case 8:
            this.showCreateDocumentElemOverlay = true
            break
        }
      } else {
        // AK: show Validation screen again without refreshing validation list
        this.showValidateCourseOverlay = true
      }
    },
    upateAddBonusContentOverlayFlag (value) {
      // AK: Used to close the Add Bonus Video Element in bonus Module Screen
      this.closeAllOverlay()
      // AK: Again show validate course screen
      this.showValidateCourseOverlay = true
      // AK: If user update respective overlay, then refresh validate list
      if (value.isUpdated) {
        this.validateCourse()
      } else {
        // AK: If user explictly closed update element overlay then show again validate screen without refreshing list
        this.showValidateCourseOverlay = true
        // AK: Disable Background Scrolling
        this.$store.state.isOverlayVisible = true
      }
    },
    closeBonusOverlay (value) {
      // AK: Used to hide bonus module creation overlay if user pressed X explicitly
      this.showBonusModuleCreationOverlay = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value

      // AK: Again open add bonus content overlay
      this.showUpdateBonusElemOverlay = true
      // AK: Disabled Background Scrolling
      this.$store.state.isOverlayVisible = true
    },
    updateNotCreatedBonusModule (value) {
      // AK: If user created/ already present bonus module then update flag as true else false
      this.isBonusModuleCreated = value
      // AK: If bonus module created then only set showMsg as true
      if (value === true) {
        this.showMsg = true
      }
    },
    updateShowAssociateMsgFlag (value) {
      // AK: After showing msg to user on create bonus element set flag again as flase
      this.showMsg = false
    },
    openBonusModuleCreationOverlay (value) {
      // AK: Used to show bonus module creation overlay
      this.showBonusModuleCreationOverlay = value
      // AK: Disable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    closeValidateCourseOverlay (value) {
      // AK: If user pressed X of validate overlay then hide overlay
      this.showValidateCourseOverlay = value
      // AK: Enable scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateClickedCreateCourse: function () {
      // ToDo: Track this
      this.$emit('clickedCreateCourse', this.clickedCreateCourse)
    },
    validateSelectedCourse: function () {
      if (this.selectedCourseObj !== null) {
        // AK: Assign first selectedCourseObj to currentCourseObj in state
        this.$store.state.currentCourseObj = this.selectedCourseObj
        // AK: Issue server call
        this.validateCourse()
      } else {
        this.showAlertDialog = true
        this.errorMsg = (this.isComingFrom === constants.CourseSearchBarEnum.Course) ? 'Please select a valid master class.' : 'Please select a valid assessment.'
      }
    },
    showLessonList: function () {
      if (this.selectedCourseObj !== null) {
        this.getLessons()
      } else {
        this.showAlertDialog = true
        this.errorMsg = (this.isComingFrom === constants.CourseSearchBarEnum.Course) ? 'Please select a valid master class.' : 'Please select a valid assessment.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      // AK: If all errors are fixed then close validation overlay also
      if (this.isAllErrorFixed) {
        this.isAllErrorFixed = false
        this.showValidateCourseOverlay = false
        // AK: Assign selected currently fixed course obj to list and load respective lesson list
        this.selectedCourseObj = this.$store.state.currentCourseObj
        this.$store.state.currentCourseObj = {}
        this.showLessonList()
      }
    },
    getLessons () {
      if (this.selectedCourseObj.CourseMasterId !== undefined) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        var storeObj = this.$store
        var _this = this
        moduleService
          .listModules(
            storeObj.state.access_token,
            _this.selectedCourseObj.CourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              storeObj.state.selectedMasterClassModuleList = responseObj.data
              this.$store.state.selectedCourseObjFromFilter = this.selectedCourseObj
              this.$store.state.isLessonSwipped = false
              this.$emit('checkAndShowLessonList', true)
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }, errorObj => {
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        this.showAlertDialog = true
        this.errorMsg = (this.isComingFrom === constants.CourseSearchBarEnum.Course) ? 'Please select a valid master class.' : 'Please select a valid assessment.'
      }
    },
    increaseComponentHeight: function (evt) {
      console.log('DATA LOADED FOR TYPEHEADE : ')
      this.autoCompleteVisible = true
    },
    decreaseComponentHeight: function (evt) {
      this.autoCompleteVisible = false
    },
    UploadCourseCSVOverlay: function () {
      // AK: open CSV Course overlay
      this.showUploadCourseCSVOverlay = true
      // AK: Disable background scrolling
      this.$store.state.isOverlayVisible = true
    },
    closeUploadCourseCSVOverlay (value) {
      // AK: used to hide OPEN CSV COURSE overlay after clicking on done or X
      this.showUploadCourseCSVOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    uploadedCourseCSVServerResponse (value) {
      // AK: Used to store the ErrorList recieved after uploading Course CSV
      this.serverErrorRespArr = value
      // AK: Close Upload CSV overlay and open Validate Course details overlay
      this.showUploadCourseCSVOverlay = false
      this.showValidateCourseOverlay = true
    },
    updateSelectedErrorObj (value) {
      // AK: when user selects any error to fix, then as per type of Obj show respective overlay
      this.selectedErrorObj = value
      switch (this.selectedErrorObj.ObjectType) {
        case 'CourseMaster':
          this.openRespectiveOverlay()
          break
        case 'Module':
          // console.log('this.selectedErrorObj >> ' + JSON.stringify(this.selectedErrorObj))
          this.getSingleModule(this.selectedErrorObj.ObjectId)
          break
        default:
          this.getSingleElement()
          break
      }
    },
    openRespectiveOverlay: function () {
      // AK: Close course validation Overlay and open respective overlay
      this.showValidateCourseOverlay = false
      this.closeAllOverlay()
      // AK: Disable Background Scrolling
      this.$store.state.isOverlayVisible = true
      switch (this.selectedErrorObj.ObjectType) {
        case 'CourseMaster':
          this.showUpdateCourseOverlay = true
          break
        case 'Challenge':
          this.showUpdateChallengeElemOverlay = true
          break
        case 'Document':
          this.showUpdateDocumentElemOverlay = true
          break
        case 'BonusContent':
          this.isBonusModuleCreated = true
          this.showUpdateBonusElemOverlay = true
          break
        case 'TextPage':
          this.showUpdateNoteElemOverlay = true
          break
        case 'MCQ':
          this.showUpdateMCQElemOverlay = true
          break
        case 'Video':
          this.showUpdateVideoElemOverlay = true
          break
        case 'R & D':
          this.showUpdateRDElemOverlay = true
          break
        case 'Module':
          // console.log('Selected Module Obj' + JSON.stringify(this.selectedErrorModuleObj))
          if (this.selectedErrorModuleObj.IsBonusContent) {
            // AK: Show add bonus element overlay
            this.showAddBonusVideoElementOverlay = true
          } else {
            // AK: Open select Element type overlay
            this.showSelectElemTypeOverlay = true
          }
          break
      }
    },
    closeAllOverlay: function () {
      this.showUpdateCourseOverlay = false
      this.showUpdateChallengeElemOverlay = false
      this.showUpdateDocumentElemOverlay = false
      this.showUpdateBonusElemOverlay = false
      this.showUpdateNoteElemOverlay = false
      this.showUpdateRDElemOverlay = false
      this.showUpdateVideoElemOverlay = false
      this.showUpdateMCQElemOverlay = false
      this.showAddBonusVideoElementOverlay = false
      this.showSelectElemTypeOverlay = false
      this.showCreateChallengeElemOverlay = false
      this.showCreateDocumentElemOverlay = false
      this.showCreateMcqElemOverlay = false
      this.showCreateNoteElemOverlay = false
      this.showCreateRDElemOverlay = false
      this.showCreateVideoElemOverlay = false
    },
    getSingleElement () {
      if (this.selectedErrorObj.ObjectId !== undefined) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        var storeObj = this.$store
        var _this = this
        elementService
          .getSingleElement(
            storeObj.state.access_token,
            _this.selectedErrorObj.ObjectId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.selectedErrorElemObj = responseObj.data
              // AK: get single Module
              this.getSingleModule(this.selectedErrorElemObj.ModuleId)
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }, errorObj => {
            // _this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log('Element Id / Object Id is null hence Declined getSingleElement Operation')
      }
    },
    getSingleModule (moduleId) {
      if (this.selectedErrorElemObj !== undefined) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        var storeObj = this.$store
        var _this = this
        moduleService
          .getSingleModule(
            storeObj.state.access_token,
            moduleId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.selectedErrorModuleObj = responseObj.data
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.openRespectiveOverlay()
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }, errorObj => {
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log('Element Id / Object Id is null hence Declined getSingleElement Operation')
      }
    },
    closeOverlay (value) {
      // AK: Close overlay
      this.closeAllOverlay()
      // AK: Again show validate course screen
      this.showValidateCourseOverlay = true
      // AK: If user update respective overlay, then refresh list
      if (value.isUpdated) {
        this.validateCourse()
      } else {
        // AK: If user explictly closed update element overlay then show again validate screen without refreshing list
        this.showValidateCourseOverlay = true
        // AK: Disable Background Scrolling
        this.$store.state.isOverlayVisible = true
      }
    },
    validateCourse () {
      var storeObj = this.$store
      if (storeObj.state.currentCourseObj !== undefined) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        var _this = this
        courseService
          .validateCourse(
            storeObj.state.access_token,
            storeObj.state.currentCourseObj.CourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.serverErrorRespArr = responseObj.data.Errors
              // console.log('validateCourse >>>> ' + JSON.stringify(this.serverErrorRespArr))
              // this.showSpinner = false
              this.$store.state.isLoading = false
              if (this.serverErrorRespArr.length !== 0) {
                this.showValidateCourseOverlay = true
              } else {
                this.isAllErrorFixed = true
                this.showAlertDialog = true
                this.errorMsg = 'Congratulations!! All errors are fixed.'
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }, errorObj => {
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log('currentCourseObj is null hence Declined Validate Course Operation')
      }
    }
  },
  computed: {
    getIsComingFromValue: {
      get: function () {
        return this.isComingFrom
      }
    },
    courses: {
      get: function () {
        return filter(this.$store.state.course_list, (obj) => {
          if (this.getIsComingFromValue === constants.CourseSearchBarEnum.Course) {
            return (obj.Type !== constants.CourseType.RecommendationAssessment)
          } else {
            return (obj.Type === constants.CourseType.RecommendationAssessment)
          }
        })
      }
    },
    getSelectedErrorObj: {
      get: function () {
        return this.selectedErrorObj
      }
    },
    getErrorElementObj: {
      get: function () {
        return this.selectedErrorElemObj
      }
    },
    getErrorModuleObj: {
      get: function () {
        return this.selectedErrorModuleObj
      }
    },
    getServerErrorRespArr: {
      get: function () {
        return this.serverErrorRespArr
      }
    }
  },
  components: {
    Typeahead,
    Autocomplete,
    'alert-box': AlertBox,
    'loader': Loader
  },
  watch: {
    newlyCreatedCourseObj: function (newVal, oldVal) {
      // console.log('newlyCreatedCourseObj >>> ' + JSON.stringify(newVal))
      if (newVal !== null) {
        this.selectedCourseObj = newVal
        this.getLessons()
      }
    }
  },
  name: 'MainDiv'
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.margin-Right-2Point4Perc {
  margin-right: 2.4% !important;
}
.text-align-center {
  text-align: center;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}
.icon-addon {
  position: relative;
  color: #555;
  display: block;
}
.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}
.icon-addon:after {
  clear: both;
}
.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}
.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  /* padding: 10px 16px 10px 40px; */
  padding: 7px 16px 6px 40px;
}
.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}
.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}
.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}
.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}
.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-color-red {
  background-color: red;
}
.cf-border {
  border: 1px solid black;
}
.text-align-left {
  text-align: left;
}
.cart {
  width: 600px;
}
.checkout-table {
  width: 100%;
}
.checkout-table th {
  text-align: left;
  padding: 15px 0px;
  border-bottom: 1px solid #aaa;
}
.checkout-table td {
  padding: 8px 0px;
}
.checkout-button {
  float: right;
  width: 120px;
  height: 40px;
  margin-top: 20px;
}
.total td {
  border-top: 1px solid #aaa;
  padding-top: 10px;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-12px {
  font-size: 12px;
}
.font-size-18px {
  font-size: 18px;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
 /* #typeheadSearch.dropdown{
  position: relative ;
}  */
.height300{
  /* height: 330px; */
  height: 630px;
  overflow-y: scroll;
}
heightAuto{
  height: auto;
}
.dropdown {
  position: static !important;
  /* display:none!important; */
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-top-3px{
  margin-top: 3px !important;
}
.text-align-right {
  text-align: right;
}
.margin-right-1Perc{
  margin-right: 1%;
}
.padding-right-0Perc{
  padding-right:0%;
}
.padding-right-1Perc{
  padding-right:1%;
}
.width-14Perc{
  width:14%;
}
.margin-left-1Point6Perc{
  margin-left:1.6%;
}
.width-15Perc{
  width:15% !important;
}
.margin-left2Point8Perc{
  margin-left:2.8% !important;
}
.padding-left-2Point4Perc{
  padding-left:2.4%;
}
.padding-left-0Perc{
  padding-left: 0%;
}
.padding-left-4Point5Perc{
  padding-left:4.5%;
}
.padding-left-2Perc{
  padding-left:2%;
}
.width-7Perc{
  width:7%;
}
.margin-bottom-0Perc{
  margin-bottom: 0%;
}
.padding-left-10Perc{
  padding-left: 10%;
}
.padding-1Point4Perc{
  padding: 1.4%;
}
.width-0Perc{
  width:0%;
}
.padding-top-32px{
  padding-top:32px;
}
.margin-top-Point1Perc{
  margin-top:.1%;
}
.padding-left-5px{
  padding-left:5px;
}
.padding-left-1Point8Perc{
  padding-left:1.8%;
}
</style>





// WEBPACK FOOTER //
// src/components/CourseSearchBar.vue